(function (window, document) {
  'use strict';

  var STATE = {
    root: null,
    timer: null,
    raf: null,
    cancelled: false,
    started: 0,
    onCancel: null,
    keyHandler: null,
  };

  function t(key) {
    var i18n = window.buybackPortalI18n || {};
    return i18n[key] || key;
  }

  function prefersReducedMotion() {
    try {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    } catch (e) {
      return false;
    }
  }

  function clear(opts) {
    var fireOnCancel = !!(opts && opts.fireOnCancel);
    var cb = STATE.onCancel;
    if (STATE.timer) {
      clearTimeout(STATE.timer);
      STATE.timer = null;
    }
    if (STATE.raf) {
      cancelAnimationFrame(STATE.raf);
      STATE.raf = null;
    }
    if (STATE.keyHandler) {
      document.removeEventListener('keydown', STATE.keyHandler);
      STATE.keyHandler = null;
    }
    if (STATE.root && STATE.root.parentNode) {
      STATE.root.parentNode.removeChild(STATE.root);
    }
    STATE.root = null;
    STATE.cancelled = false;
    STATE.started = 0;
    STATE.onCancel = null;
    if (fireOnCancel && cb) cb();
  }

  function buildDom(message, undoLabel) {
    var root = document.createElement('div');
    root.className = 'bp-toast';
    root.setAttribute('role', 'status');
    root.setAttribute('aria-live', 'polite');

    var inner = document.createElement('div');
    inner.className = 'bp-toast__inner';

    var msg = document.createElement('span');
    msg.className = 'bp-toast__message';
    msg.textContent = message;
    inner.appendChild(msg);

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'bp-toast__undo';
    btn.textContent = undoLabel;
    btn.setAttribute('data-bp-toast-undo', '');
    inner.appendChild(btn);

    var progress = document.createElement('div');
    progress.className = 'bp-toast__progress';
    progress.setAttribute('data-bp-toast-progress', '');
    var fill = document.createElement('span');
    fill.className = 'bp-toast__progress-fill';
    progress.appendChild(fill);

    root.appendChild(inner);
    root.appendChild(progress);
    return root;
  }

  function animateProgress(fill, delayMs, msgEl, messageTpl) {
    if (prefersReducedMotion() || !fill) return;
    STATE.started = performance.now ? performance.now() : Date.now();
    var lastSeconds = -1;
    function step(now) {
      var current = now || (performance.now ? performance.now() : Date.now());
      var elapsed = current - STATE.started;
      var ratio = Math.min(1, elapsed / delayMs);
      fill.style.transform = 'scaleX(' + (1 - ratio) + ')';
      // Update text only when remaining seconds change (throttle DOM writes)
      if (msgEl && messageTpl) {
        var remaining = Math.max(0, Math.ceil((delayMs - elapsed) / 1000));
        if (remaining !== lastSeconds) {
          lastSeconds = remaining;
          msgEl.textContent = messageTpl.replace('{{ seconds }}', String(remaining));
        }
      }
      if (ratio < 1 && !STATE.cancelled) {
        STATE.raf = requestAnimationFrame(step);
      }
    }
    STATE.raf = requestAnimationFrame(step);
  }

  function confirmWithUndo(opts) {
    opts = opts || {};
    var delayMs = typeof opts.delayMs === 'number' && opts.delayMs > 0 ? opts.delayMs : 3000;
    var messageTpl = opts.messageTpl || null;
    var reduced = prefersReducedMotion();
    var staticMessage = opts.message || t('toast_action_pending') || 'Action en cours…';
    // Reduced motion → message statique (pas de countdown DOM updates)
    var initialMessage;
    if (messageTpl && !reduced) {
      initialMessage = messageTpl.replace('{{ seconds }}', String(Math.ceil(delayMs / 1000)));
    } else {
      initialMessage = staticMessage;
    }
    var undoLabel = opts.undoLabel || t('toast_undo') || 'Annuler';
    var onConfirm = typeof opts.onConfirm === 'function' ? opts.onConfirm : null;
    var onCancel = typeof opts.onCancel === 'function' ? opts.onCancel : null;

    // Si un toast actif est remplacé, son onCancel doit être notifié pour
    // éviter qu'une action undo-able précédente reste en suspens.
    clear({ fireOnCancel: true });

    var root = buildDom(initialMessage, undoLabel);
    document.body.appendChild(root);
    var msgEl = root.querySelector('.bp-toast__message');
    STATE.root = root;
    STATE.cancelled = false;
    STATE.onCancel = onCancel;

    var fill = root.querySelector('.bp-toast__progress-fill');
    animateProgress(fill, delayMs, msgEl, messageTpl && !reduced ? messageTpl : null);

    var doCancel = function () {
      STATE.cancelled = true;
      var cb = STATE.onCancel;
      STATE.onCancel = null;
      clear();
      if (cb) cb();
    };

    var undoBtn = root.querySelector('[data-bp-toast-undo]');
    if (undoBtn) undoBtn.addEventListener('click', doCancel);

    STATE.keyHandler = function (e) {
      if (e.key === 'Escape' || e.keyCode === 27) doCancel();
    };
    document.addEventListener('keydown', STATE.keyHandler);

    STATE.timer = setTimeout(function () {
      if (STATE.cancelled) return;
      STATE.onCancel = null;
      clear();
      if (onConfirm) onConfirm();
    }, delayMs);
  }

  function info(message, delayMs) {
    delayMs = typeof delayMs === 'number' && delayMs > 0 ? delayMs : 3000;
    message = message || '';
    clear({ fireOnCancel: true });
    var root = document.createElement('div');
    root.className = 'bp-toast';
    root.setAttribute('role', 'status');
    root.setAttribute('aria-live', 'polite');
    var inner = document.createElement('div');
    inner.className = 'bp-toast__inner';
    var msg = document.createElement('span');
    msg.className = 'bp-toast__message';
    msg.textContent = message;
    inner.appendChild(msg);
    root.appendChild(inner);
    document.body.appendChild(root);
    STATE.root = root;
    STATE.cancelled = false;
    STATE.timer = setTimeout(clear, delayMs);
  }

  function dismiss() {
    STATE.cancelled = true;
    STATE.onCancel = null;
    clear();
  }

  window.BuybackPortalToast = {
    confirmWithUndo: confirmWithUndo,
    dismiss: dismiss,
    info: info,
  };
})(window, document);
